export default __webpack_public_path__ + "static/media/queue_red_warning.28da8cbf.svg";